export const getCurrentVersion = () => {
  const versionMajor = 4; // major version
  const versionMinor = 0; // minor version
  const versionPatch = 0; // patch version
  return `Version ${versionMajor}.${versionMinor}.${versionPatch}`;
};
